<svg
  xmlns="http://www.w3.org/2000/svg"
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 24 24"
  fill="none"
  focusable="false"
  aria-hidden="true"
>
  <path
    [attr.fill]="fillColor"
    d="M18.667 24H5.333a5.298 5.298 0 0 1-3.77-1.562A5.298 5.298 0 0 1 0 18.667v-1.334a1.333 1.333 0 1 1 2.667 0v1.334c0 .712.277 1.382.78 1.885a2.65 2.65 0 0 0 1.886.781h13.334a2.65 2.65 0 0 0 1.885-.78 2.65 2.65 0 0 0 .781-1.886v-1.334a1.333 1.333 0 1 1 2.667 0v1.334a5.298 5.298 0 0 1-1.562 3.77A5.298 5.298 0 0 1 18.667 24ZM12 18.667a1.33 1.33 0 0 1-.931-.38l-.003-.002-.001-.001-.002-.002-.001-.002h-.002a.04.04 0 0 0-.003-.004l-5.333-5.333a1.333 1.333 0 0 1 1.885-1.886l3.058 3.057V1.334a1.333 1.333 0 1 1 2.666 0v12.78l3.057-3.057a1.333 1.333 0 0 1 1.886 1.886l-5.333 5.333a.04.04 0 0 0-.003.003l-.002.001-.001.002-.002.002-.003.003a1.326 1.326 0 0 1-.412.274l-.002.001h-.001a1.328 1.328 0 0 1-.517.105Z"
  />
</svg>
